// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
import React from 'react'
import { DeleteOutlined, EditOutlined, LinkOutlined, StopOutlined } from '@ant-design/icons'
import './action-creator.less'
import { AllStages, JobStatus, TaskStatus } from '../../constants/job'
import { number } from 'prop-types'
import { Tooltip } from 'antd'
/**
 *
 * @param status
 * @param level
 * @returns  sometype
 */
const getTypeByStatus = () => {}
const getActionsByStatus = (level: string, status: number) => {
  let actions = []
  if (level === 'job' && status === JobStatus.Pending) {
    actions = ['stop', 'delete', 'edit']
  } else if (level === 'job' && status === JobStatus.Processing) {
    actions = ['stop']
  } else if (level === 'job' && status === JobStatus.Successful) {
    actions = []
  } else if (level === 'job' && status === JobStatus.Stopped) {
    actions = []
  } else if (level === 'task' && status === TaskStatus.Pending) {
    actions = ['stop']
  } else if (level === 'task' && status === TaskStatus.Uploading) {
    actions = ['stop']
  } else if (level === 'task' && status === TaskStatus.UploadingKV) {
    actions = []
  } else if (level === 'task' && status === TaskStatus.Stitching) {
    actions = []
  } else if(level === 'task' && status === TaskStatus.Stopped){
    actions = ['link']
  } else if(level === 'task' && status === TaskStatus.Stitched){
    actions = ['link']
  } else if (level === 'task' && status === TaskStatus.Successful) {
    actions = ['link']
  }
  return actions
}
const ActionCreator = props => {
  const { type, actions, target } = props
  const [level, status] = type.split(':')
  const allTypes = getActionsByStatus(level, Number(status))
  return (
    <div className={'action-container'}>
      {allTypes.includes('edit') ?
      <Tooltip placement='top' title='Modify'>
          <EditOutlined onClick={actions.edit.bind(null, target)} />
      </Tooltip>
      : null}
      {allTypes.includes('delete') ?
      <Tooltip placement='top' title='Delete Task'>
       <DeleteOutlined onClick={actions.delete.bind(null, target)} />
      </Tooltip>
       : null}
      {allTypes.includes('link') && target.sequenceID ? (
        <Tooltip placement='top' title='Upload Link Available'>
          <LinkOutlined onClick={actions.jumpTo.bind(null, target)} />
        </Tooltip>
      ) : null}
      {allTypes.includes('stop') && target.groupID === 0 ?
      <Tooltip placement='top' title='Stop Upload'>
       <StopOutlined onClick={actions.stop.bind(null, target)} />
      </Tooltip>
        : null}
    </div>
  )
}
export { ActionCreator }
